import React from "react";
import classes from "../../styles/Gallery.module.css";
import GalleryElHeaderDate from "./GalleryElHeaderDate";

const GalleryElementHeader = ({ category, date }) => {
  return (
    <div className={classes.header}>
      <p>{category}</p>
      <GalleryElHeaderDate date={date} />
    </div>
  );
};

export default GalleryElementHeader;
